import dayjs from 'dayjs'
import { Branded } from 'types'
import { DATE_FORMAT } from 'utils/fde/constants'

/* eslint-disable @typescript-eslint/no-explicit-any */

export function isEnum<T>(enumObj: any): (value: any) => value is T {
  return (value: any): value is T => {
    return Object.values<T>(enumObj).includes(value)
  }
}

export enum ApiCode {
  Api653 = 'api653',
  Api570 = 'api570',
}

export const isApiCode = isEnum<ApiCode>(ApiCode)

/**
 * Formatted as YYYY-MM-DD
 */
export type DateString = Branded<string, 'DateString'>

export function isDateString(value: any): value is DateString {
  if (typeof value !== 'string') {
    return false
  }

  const date = dayjs(value, DATE_FORMAT)
  return date.isValid()
}

/**
 * Formatted as an ISO8601 time string
 */
export type TimeString = Branded<string, 'TimeString'>
